import component from '../../../../props/component'
import form from '../../../../props/form'
import processing from '../../../../props/processing'

const localProps = {
  title: {
    type: String,
    default() {
      return this.$options.$$t('title', '')
    }
  },
  showTitle: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showTitle', false)
    }
  },
  subTitle: {
    type: String,
    default() {
     return this.$options.$$t('subTitle', null)
    }
  },
  showSubTitle: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showSubTitle', false)
    }
  },
  notice: {
    type: String,
    default() {
     return this.$options.$$t('notice', null)
    }
  },
  showNotice: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showNotice', true)
    }
  },

  classes: {
    type: [String, Array, Object],
     default() {
      return this.$options.$$s('classes', null)
    }
  },

  loadingMessage: {
    type: String,
    default() {
      return this.$options.$$t('loadingMessage', 'Loading orders...')
    }
  },

  view: {
    type: String,
    default() {
      return this.$options.$$t('view.type', 'list') //grid
    }
  },
  listViewMinWidth: {
    type: [Number, String],
    default() {
      return this.$options.$$s('view.list.minWidth', 992)
    }
  },
  paginate: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('table.paginate', true)
    }
  },
  pageSize: {
    type: [Number, String],
    default() {
      return this.$options.$$s('table.page.size', 10)
    }
  },
  pageStart: {
    type: [Number, String],
    default() {
      return this.$options.$$s('table.page.start', 0)
    }
  },
  dateFormat: {
    type: [Number, String],
    default() {
      return this.$options.$$s('table.cell.dateFormat', null)
    }
  },

}
export const props = {
  ...component,
  ...form,
  ...processing,
  ...localProps
}
export default props
